import React, { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import ApprovalTemplate from '../../components/common/approval/ApprovalTemplate';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TitleBox from '../../components/common/breadcrumbs/TitleBox';
import { unloadTech } from '../../modules/techModule/tech';
import { unloadMidTechs } from '../../modules/techModule/techMids';
import { unloadTechPlan } from '../../modules/techModule/techPlan';
import { unloadTechRslt } from '../../modules/techModule/techRslt';
import { viewApproval } from '../../modules/userModule/approval';

import ApprovalOrderViewContainer from './ApprovalOrderViewContainer';
import ApprovalTechViewContainer from './ApprovalTechViewContainer';
import ApprovalTaxViewContainer from './ApprovalTaxViewContainer';
import * as approvalApi from '../../lib/api/approval';
import AskDialog from '../../components/common/dialog/AskDialog';

const ApprovalViewContainer = () => {
  const { enqueueSnackbar } = useSnackbar();
  //docuCd : 세금 -> trjUuid, 수주-> roUuid, 기술:techUuid
  const { id } = useParams();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [titleData, setTitleData] = useState(null);

  const { user, approval, error, loading } = useSelector(
    ({ auth, userModule, loading }) => ({
      user: auth.user,
      approval: userModule.approval.approval,
      error: userModule.approval.error,
      loading: loading['user/VIEW_APPROVAL'],
    }),
  );

  useEffect(() => {
    // id : docuUuid
    dispatch(viewApproval(id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (approval) {
      const name = approval.docyTyp + ' [' + approval.docuNo + ']';
      setTitleData({ name: name });
    }
  }, [approval]);

  const handleGoBack = () => {
    dispatch(unloadTech());
    dispatch(unloadTechPlan());
    dispatch(unloadMidTechs());
    dispatch(unloadTechRslt());
    navigate('/approvalmng');
  };

  const [removeVisible, setRemoveVisible] = useState(false);
  const handleDelete = () => {
    setRemoveVisible(true);
  };
  const onDeleteCancle = () => {
    setRemoveVisible(false);
  };
  const onDeleteConfirm = () => {
    //삭제
    onDelete();
    setRemoveVisible(false);
  };

  const onDelete = async () => {
    try {
      const res = await approvalApi.deleteApproval(id);

      if (res.data.result === 'success') {
        navigate('/approvalmng');
        enqueueSnackbar('결제가 삭제되었습니다', {
          variant: 'success',
        });
      } else {
        enqueueSnackbar('결제 삭제에 실패하였습니다.', {
          variant: 'error',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  return (
    <ApprovalTemplate approval={approval} loading={loading} error={error}>
      <TitleBox
        handleGoBack={handleGoBack}
        menuName="공통관리/결재관리/결재상세"
        menuLink="/approvalmng"
        icon="approval"
        titleData={titleData}
      />
      {approval?.docuYn === 'S' && user?.usrUuid === approval?.crtUsr && (
        <Stack
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
          sx={{ my: 1 }}
        >
          <Button variant="contained" color="error" onClick={handleDelete}>
            결재 삭제
          </Button>
        </Stack>
      )}
      {approval && approval.docyTyp === '수주' && (
        <ApprovalOrderViewContainer id={approval?.docuCd} />
      )}
      {approval && approval.docyTyp === '세금' && (
        <ApprovalTaxViewContainer id={approval?.docuCd} />
      )}
      {approval && approval.docyTyp === '기술' && (
        <ApprovalTechViewContainer id={approval?.docuCd} />
      )}
      <AskDialog
        visible={removeVisible}
        title="결재 삭제"
        description="해당 결재를  삭제 처리 하시겠습니까?(복구 불가)"
        onConfirm={onDeleteConfirm}
        onCancle={onDeleteCancle}
      />
    </ApprovalTemplate>
  );
};

export default ApprovalViewContainer;
